import { Outlet } from 'react-router-dom';

import LaffMoreHeader from './partials/LaffMoreHeader';
import LaffMoreFooter from './partials/LaffMoreFooter';

export default function BasePageLayout() {
    return (<site-wrapper>
        <LaffMoreHeader />
        <main className="main-content" role="main">
            <Outlet />
        </main>
        <LaffMoreFooter />
    </site-wrapper>)
}
